import { useQuery } from '@tanstack/react-query';

import { User } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';

const RESOURCE = '/users/user/';

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    is_active?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<User>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...params }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, params],
        queryFn: async () => await queryFn(params),
        ...config,
    });

export { RESOURCE as LIST_USERS_RESOURCE, queryFn as listUsers, useQueryHook as useListUsers };
